import React from "react";

function Footer() {
  return (
    <footer className="bg-primary text-white py-10">
      <div className="container mx-auto px-6 flex justify-between">
        {/* Logo column */}
       <div className="mb-6 md:mb-0 bg-white p-2 rounded-md inline-block">
  <img src="/mtclogo.svg" alt="Moving The Chainz Logo" className="w-40 h-40" />
</div>


        {/* Services column */}
        <div className="flex flex-col items-center w-1/3 text-center">
          <h3 className="font-heading text-xl font-bold mb-4">Services</h3>
          <ul className="space-y-2">
            <li>Alignments</li>
            <li>Suspensions</li>
            <li>Brakes</li>
            <li>Auto Repairs</li>
            <li>Pre-Owned Car Sales</li>
          </ul>
        </div>

        {/* Contact column */}
        <div className="flex flex-col items-center w-1/3 text-center">
          <h3 className="font-heading text-xl font-bold mb-4">Contact Us</h3>
          <p>Phone: (205) 434-1344 </p>
          <p>Address: 7433 1st Ave N, Birmingham, AL 35206</p>
          <p>Our Hours: </p>
          <ul>Sales: Mon-Sat, 9AM - 6PM</ul>
          <ul>Service: Mon-Sat, 8AM - 5PM</ul>
          <ul>Sunday: Closed</ul>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
